// import BRANDING from "../Variables";
// export function getBranding() {
//   const host = window.location.hostname; 

//   if (host === "localhost" || host === "127.0.0.1") {
//     return BRANDING.alhamedglobal; 
//   }

//   const parts = host.split(".");

//   const subdomain = parts.length > 2 ? parts[0] : "default";

//   return BRANDING[subdomain] || BRANDING.default;
// }

import BRANDING from "../Variables";

export function getBranding() {
  const host = window.location.hostname; 

  // Handle localhost development
  if (host === "localhost" || host === "127.0.0.1") {
    return BRANDING.equinox; 
  }

  const parts = host.split(".");
  let subdomain;

  if (parts.includes("alhamedglobal")) {
    subdomain = "alhamedglobal";
  } else {
    subdomain = parts.length > 2 ? parts[0] : "default";
  }

  return BRANDING[subdomain] || BRANDING.default;
}
